class BrowserUtil {
    static detectBrowser(browser) {
        if (typeof navigator === 'undefined') {
            return false;
        }
        const ua = navigator.userAgent || navigator.vendor;
        return ua.includes(browser);
    }
    static isBrowserInstagram() {
        return this.detectBrowser(this.USER_AGENT_INSTAGRAM);
    }
}
BrowserUtil.USER_AGENT_INSTAGRAM = 'Instagram';
export default BrowserUtil;
